<dashboardnav>
  <div class="reference_body">
    <main class="reference_main">
      <div class="pink_box"></div>
      <div class="green_box"></div>
  <div [ngSwitch]="task">
    <ng-template ngSwitchCase = "list">
      <!-- <pre>{{isLoadingProjectCluster$ | async }}</pre> -->
      <mrsoftapps-budget-performance
      [countries]="country$ | async"
      [states]="state$ | async"
      [lgas]="lga$ | async"
      [projectTypes]="projectType$ | async"
      [projectCategories]="projectCategory$ | async"
      [oilBlocks]="oilBlock$ | async"
      [oilFields]="oilField$ | async"
      [communities]="community$ | async"
      [clusters]="cluster$ | async"
      [currencies]="currency$ | async"
      [clusterCommunity]="clusterCommunity$ | async"
      [projectManagements]="projectManagement$ | async"
      [projectClusters]="projectCluster$ | async"
      [projectPayments]="projectPayment$ | async"
      [projectStakeholders]="projectStakeholder$ | async"
      [gmous]="gmou$ | async"
      [banks]="bank$ | async"
      [bankDetails]="bankDetail$ | async"
      [documentCategory]="documentCategory$ | async"
      [documentSubCategory]="documentSubCategory$ | async"
      (changeEmit)="onTriggerEmit($event)"
      (onActivityEmit)="onEmitActivity($event)"
      (deleteEvent)="onDeleteEVent($event)"
      (onBankDetailEmit)="createBankDetail($event)"
      (deleteBankDetailEvent)="deleteBankDetail($event)"
      (getBankDetailEmit)="getBankDetail($event)"
      (onDeleteStakeholder)="onDeleteStakeholder($event)"
      (onSaveProjectStakeholder)="onsaveProjectStakeholder($event)"
      (onSaveProjectPayment)="onSaveProjectPayment($event)"
      (onSaveProjectCluster)="onSaveProjectCluster($event)"
      (onDeleteCluster)="onDeleteCluster($event)"
      (taskEmit)="taskEvent($event)"
      *ngIf="
      !(isLoadingProjectManagement$ | async) &&
      !(isLoadingCountry$ | async) &&
      !(isLoadingState$ | async) &&
      !(isLoadingLga$ | async) &&
      !(isLoadingCommunity$ | async) &&
      !(isLoadingProjectType$ | async) &&
      !(isLoadingCluster$ | async) &&
      !(isLoadingClusterCommunity$ | async) &&
      !(isLoadingProjectCategory$ | async) &&
      !(isLoadingOilBlock$ | async) &&
      !(isLoadingOilField$ | async) &&
      !(isLoadingDocumentCategory$ | async) &&
      !(isLoadingDocumentSubCategory$ | async) &&
      !(isLoadingGmou$ | async) &&
      !(isLoadingCurrency$ | async) &&
      !(isLoadingProjectCluster$ | async) &&
      !(isLoadingProjectStakeholder$ | async) &&
      !(isLoadingBank$ | async) &&
      !(isLoadingProjectPayment$ | async)
    "
      >


      </mrsoftapps-budget-performance>

    </ng-template>

  </div>



<mrsoftapps-epims-reference-spinner
*ngIf="
(isLoadingProjectManagement$ | async) ||
(isLoadingCountry$ | async) ||
(isLoadingState$ | async) ||
(isLoadingLga$ | async) ||
(isLoadingCommunity$ | async) ||
(isLoadingProjectType$ | async) ||
(isLoadingCluster$ | async) ||
(isLoadingClusterCommunity$ | async) ||
(isLoadingProjectCategory$ | async) ||
(isLoadingOilBlock$ | async) ||
(isLoadingOilField$ | async) ||
(isLoadingDocumentCategory$ | async) ||
(isLoadingDocumentSubCategory$ | async) ||
(isLoadingGmou$ | async) ||
(isLoadingCurrency$ | async) ||
(isLoadingProjectCluster$ | async) ||
(isLoadingProjectStakeholder$ | async) ||
(isLoadingBank$ | async) ||
(isLoadingProjectPayment$ | async)
"


></mrsoftapps-epims-reference-spinner>
</main>
</div>
</dashboardnav>
